import styled from 'styled-components';
import { Upload } from 'antd';
import { theme } from '../../../consts/theme';

export const StyledUpload = styled(Upload)`
  max-width: 100%;

  svg {
    color: ${theme.colors.main};
  }

  .ant-upload-list-picture-card-container {
    width: calc(50% - 8px);
    height: 25vw;
    max-height: 240px;
  }

  .ant-upload-select {
    width: 100%;
  }

  .ant-upload-list-picture-card .ant-upload-list-item-actions {
    top: 80%;
  }

  .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-eye,
  .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-download,
  .ant-upload-list-picture-card .ant-upload-list-item-actions .anticon-delete {
    scale: 2;
    width: 38px;
    margin: 0 16px;
  }

  .ant-upload-list-picture-card .ant-upload-list-item-action,
  .ant-upload-list-item-card-actions-btn {
    opacity: 1;
    width: auto;
    height: 40px;
  }
`;
